var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Nome do Núcleo:",
                  content: _vm.imovel.nomeNucleo
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Área:",
                  content: _vm.formatAreaUnidadeMedida(
                    _vm.imovel.area,
                    _vm.imovel.unidadeMedidaArea
                  )
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Número de lotes (aproximadamente):",
                  content: _vm.imovel.numeroLotes
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Município:",
                  content: _vm.imovel.municipio ? _vm.imovel.municipio.nome : ""
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d6394a4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6394a4a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/informacoesCadastro/cadastrosOnline/informacoesReurbColetivo/InformacoesReurbColetivoImovel.vue
// module id = null
// module chunks = 